export const roomGenders = {
  male: 'male',
  female: 'female',
  none: 'none'
}

export const roomTypes = {
  lodge: 'Lodge',
  studio: 'Studio',
  queenSuite: 'Queen Suite',
  kingSuite: 'King Suite',
  mahimaStay: 'Mahima Stay',
  cabin: 'Cabin'
}

export const roomDisplaySortOrder = [
  roomTypes.lodge,
  roomTypes.studio,
  roomTypes.cabin,
  roomTypes.queenSuite,
  roomTypes.kingSuite,
  roomTypes.mahimaStay
]

export const roomConfigurations = {
  king: '1 King',
  queenTwin: '1 Queen, 1 Twin',
  queenTwinDiwan: '1 Queen, 1 Twin, 1 Diwan'
  //kingDiwan: '1 King, 1 Diwan'
}

export const roomConfigurationDetails = {
  [roomConfigurations.king]: {
    minGuests: 1,
    maxGuests: [{ adults: 2, children: 1 }, { adults: 1, children: 2 }],
    order: 0,
    displayName: 'Standard Room - 1 King Bed'
  },
  [roomConfigurations.queenTwin]: {
    minGuests: 2,
    maxGuests: [
      { adults: 3, children: 1 },
      { adults: 2, children: 2 },
      { adults: 1, children: 3 }
    ],
    order: 1,
    displayName: 'Standard Room - 1 Queen, 1 Twin Bed'
  },
  [roomConfigurations.queenTwinDiwan]: {
    minGuests: 3,
    maxGuests: [
      { adults: 4, children: 0 },
      { adults: 3, children: 2 },
      { adults: 2, children: 3 },
      { adults: 1, children: 4 }
    ],
    order: 2,
    displayName: 'Deluxe Room - 1 Queen, 1 Twin, 1 Diwan Bed'
  }
  //[roomConfigurations.kingDiwan]: {
  //  maxGuests: [
  //    {adults: 2, children: 2},
  //    {adults: 3, children: 1},
  //    {adults: 1, children: 3}
  //  ],
  //  order: 3
  //}
}



// WEBPACK FOOTER //
// ./src/constants/roomConstants.js